import { InstagramAnalyticsPostDetails } from '@anytag/graphql';
import { PostModal } from '../shared';

export interface FeedPostTemplateProps {
  className?: string;
  onCloseModal?: () => void;
  data?: InstagramAnalyticsPostDetails;
}

export const FeedPostTemplate = ({ data, className, onCloseModal }: FeedPostTemplateProps) => {
  if (!data) {
    onCloseModal?.();

    return null;
  }

  return (
    <PostModal.DetailsTemplate
      className={className}
      data={{
        caption: data.content,
        postDate: data.postDate,
        socialMedia: 'INSTAGRAM',
        postUrl: data.postUrl || '',
        images: data.mediaUrls || [],
        comments: data.commentList || [],
        info: {
          avatar: data.avatarUrl,
          followers: data.followers,
          name: data.instagramAccountName
        },
        statistics: {
          likes: data.analysis?.likes,
          comments: data.analysis?.comments,
          views: data.analysis?.views,
          saves: data.analysis?.saves,
          reach: data.analysis?.reach,
          impressions: data.analysis?.impressions
        }
      }}
    />
  );
};
